// material
import { useState } from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import BreakInTrue from '../../assets/svg/breakTime1.png';
import TimeInOut from '../../assets/svg/tIntOut.png';
import TimeInOutUnable from '../../assets/svg/unabletimeInOut.png'
import DemoRestrictionDialog from './DemoRestrictionDialog';

export default function BreakSwitch({ current_status, handleSwitchTimeBreak, disabled, isDemo, greyDisabled}) {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
    <DemoRestrictionDialog
      open={dialogOpen}
      onClose={() => setDialogOpen(false)}
    />
    <Button
      id='breakSwitch'
      fullWidth
      size="medium"
      sx={{
        borderRadius: 28,
        backgroundColor: greyDisabled ? '#878B8B!important' : (current_status === 'Break in' ? '#878B8B' : '#1F98E8'),
        boxShadow: greyDisabled ? 'none' : '0px 3px 6px rgba(0, 0, 0, 0.35)!important',
        color:'white!important',
        width: '150px',
        cursor: greyDisabled || disabled ? 'not-allowed' : (current_status === 'Time in' || current_status === 'Break out' ? 'pointer' : 'default'),

        '&:hover': {
          backgroundColor: greyDisabled ? '#cccccc' : (current_status === 'Break in' ? '#878B8B' : '#1F98E8'),
          boxShadow: greyDisabled ? 'none' : '0px 3px 6px rgba(0, 0, 0, 0.35)!important',
          color: greyDisabled ? '#666666' : 'white!important',
        }
      }}
      onClick={() => {
        if (isDemo) {
          setDialogOpen(true);
          return;
        }

        if (current_status === 'Break out') {
          handleSwitchTimeBreak(false);
        } else {
          handleSwitchTimeBreak(true);
        }
      }}
      disabled={disabled || greyDisabled || current_status === 'Break in' || false}
    >
      {current_status === 'Break in' || current_status === 'Break out' ? (
        'Time In/Out'
      ) : (
        'Break Time'
      )}
    </Button>
    </>
  );
}
